<template lang="html">
    <div class="top-bar">
        <div class="layout-width">
            <div class="logo-wrapper">
                <LogoSvg></LogoSvg>
            </div>
            <div class="top-bar-right">

                <a
                    v-if="urlBackToPortal"
                    :href="urlBackToPortal"
                    >
                        Retour au portail
                    </a>
                <router-link
                    :to="{ name: 'Account' }">
                    <el-button
                        round>
                        {{ email }}
                    </el-button>
                </router-link>

            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LogoSvg from './LogoSvg';
export default {
    name: 'TopBar',
    components: {
        LogoSvg
    },
    computed: {
        ...mapGetters([
            'currentUser'
        ]),
        urlBackToPortal(){
            return window.config.master_page_url;
        },
        email () {
            let emailValue = this.currentUser.email ? this.currentUser.email : '';
            return window.config.use_apivalo_auth ? emailValue.replace(window.config.email_suffix, '') : emailValue;
        }
    }
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables';
.alert-wrapper{
    min-height: 0px;
}
.top-bar {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: $top-bar-height;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.25);
    background: white;
    .logo-wrapper {
        display: inline-block;
        padding: 12px 20px 10px;
        width: 135px;
    }
    .top-bar-right {
        padding: 9px 20px;
        display: block;
        float: right;
    }
    .user-btn-txt {
        display: none;
    }
    @media screen and (min-width: $bp) {
        .user-btn-txt,
        .user-btn-ico {
            display: inline-block;
            vertical-align: middle;
        }
        .user-btn-ico {
            margin-right: 10px;
        }
    }
}
.user-popper {
    padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/ui/TopBar.vue